import React from 'react';
import InterpolateLink from 'src/viewLayer/components/shared/InterpolateLink';
import { useBusinessPrivacyPath, useBusinessDataPath } from 'src/viewLayer/navigation';
import { t } from 'src/viewLayer/helpers/translations';
import { Text, Box } from '@lessonnine/design-system.lib';

const DataProcessingSection = () => {
  const businessPrivacyLink = {
    name: 'businessPrivacyLink',
    path: useBusinessPrivacyPath(),
    translation: t('login.b2b.data_processing.business_privacy_link')
  };

  const businessDataLink = {
    name: 'businessDataLink',
    path: useBusinessDataPath(),
    translation: t('login.b2b.data_processing.business_data_link')
  };

  return (
    <Box padding={[16, 0, 0, 0]}>
      <Box padding={[0, 0, 16, 0]}>
        <Text
          fontSize={{ xxxsmall: 10, small: 'xsmall' }}
          fontWeight={700}
          letterSpacing={0.5}
        >
          { t('login.b2b.data_processing.title') }
        </Text>
      </Box>
      <InterpolateLink
        translation={t('login.b2b.data_processing.legal_copy')}
        firstLink={ businessPrivacyLink }
        secondLink={ businessDataLink }
      />
    </Box>
  );
};

export default DataProcessingSection;
